import React from 'react';
import { formFieldTypes } from '../../constants';

const YearInput = (props) => {
    let maxValue = props.maxValue ?? new Date().getFullYear();
    let minValue = props.minValue ?? maxValue - 10;

    if (minValue > maxValue) {
        if (props.maxValue) {
            minValue = maxValue;
        }
        else {
            maxValue = minValue;
        }
    }

    if (!props.value && props.onChange) {
        props.onChange({
            target: {
                value: maxValue,
                name: props.name,
                type: formFieldTypes.year,
                getAttribute: () => { }
            }
        });
    }

    return <select name={props.name} className="form-control" value={props.value} onChange={props.onChange} disabled={props.disabled ? "disabled" : ""}>
        {Array.from({ length: maxValue - minValue + 1 }, (_, index) => index).map(index => <option key={index} value={index + minValue} style={{ display: props.hidden ? "none" : "" }}> {index + minValue}</option>)
}
    </select>
}

export default YearInput;